import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tb-demo-nav" }
const _hoisted_2 = { class: "tb-wrap" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "lds-holder" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lds-roller" }, [
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Overview & Features")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "lds-holder" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lds-roller" }, [
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Gallery")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "tb-demo-nav-mobile"
}
const _hoisted_10 = { class: "lds-holder" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "lds-roller" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Book a", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Test Drive")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Enquire ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "tb-hide-desktop" }, "Now", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "lds-holder" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lds-roller" }, [
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Advantages")
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 4,
  class: "tb-demo-nav-button"
}
const _hoisted_24 = ["onClick"]

import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
	import { useStore } from 'vuex';
	import { IRoots, IStoreState } from '@/types';
	import { getRoots } from '@/helpers';
	import DetailOverviewCta from '@/DetailApp/DetailOverviewCta.vue';
import { EInternalFinanceTypes } from '@/enums';
	
	
export default /*#__PURE__*/_defineComponent({
  name: 'DetailDemoNav',
  setup(__props) {

	const allRoots: IRoots = getRoots();
	const {
		topbarRoot,
		headerRoot,
		bannerRoot,
		overviewCtaRoot,
		demoNavRoot,
		imageGalleryRoot,
		videoGalleryRoot,
		cubeRoot,
		formRoot,
		advantageRoot,
		similarRoot,
	} = allRoots;

	const store = useStore<IStoreState>();

	const isLoadingEl = ref<HTMLElement | null>(null);
	const isDirty = ref<boolean>(false);

	const vehicle = computed(() => store.state.DetailApp.vehicle);
	const isTestDrive = computed(() => vehicle.value.VehicleType == "Test Drive");
	const showOverview = computed(() => true);
	const showGallery = computed(() => !!imageGalleryRoot);
	// const isCampaign = computed((): boolean => store.state.DetailApp.pricing.internalFinanceType == EInternalFinanceTypes.campaign);
	const showEnquire = computed(() => !!formRoot);
	const showAdvantages = computed(() => !!advantageRoot);
	const showCustomise = computed(() => {
		if (showExternalCustomise.value){
			return vehicle.value.IsVirtual;
		}
		else {
			const hasMultiplePaints = vehicle.value.Paints.length > 1;
			const hasMultipleTrims = vehicle.value.Trims.length > 1;
			const hasMultipleRoofs = vehicle.value.Roofs.length > 1;
			const canChangeColour = hasMultiplePaints || hasMultipleTrims || hasMultipleRoofs
			return vehicle.value.IsVirtual && canChangeColour;
		}
	});
	const showExternalCustomise = computed((): boolean => {
		return store.state.DetailApp.showExternalCustomise;
	});
	const addPadding = computed((): string => {
		const addBoth = 'tb-add-padding';
		const addBottomOnly = 'tb-add-bottom-padding';
		if (showCustomise.value && !showEnquire.value) {
			return addBoth;
		}
		else if (showCustomise.value && showEnquire.value) {
			return addBottomOnly;
		}
		return '';
	});

	const handleExternalCustomiseClick = () => {
		const vl = store.state.DetailApp.vehicle.VehicleLine.toLowerCase().replace(/\s/g, '-');
		const m = store.getters['DetailApp/vehicleHash'];
		(window as any).location = `/build-price/${vl}?m=${m}&customise=true`;
	}
	const getIsLoadingClass = (el: HTMLElement | null): string => {
		return el && isLoadingEl.value == el ? 'is-loading' : '';
	};
	const handleClick = (e: Event, el: HTMLElement | null): void => {
		if (!el) return;

		isLoadingEl.value = el;

		if (el == overviewCtaRoot || el == demoNavRoot){
			scrollToEl();
			return;
		}
		if (isDirty.value){
			scrollToEl();
		}
		else {
			isDirty.value = true;
			const evt = new CustomEvent('loadAllSections');
			document.dispatchEvent(evt);
		}
	}
	const handleLoaded = () => {	
		isDirty.value = true;
		setTimeout(() => {
			scrollToEl();
		}, 2000);
	};
	const scrollToEl = () => {
		if (!isLoadingEl.value) return;
		isLoadingEl.value.scrollIntoView({ behavior: 'smooth' });
		isLoadingEl.value = null;
	}

	onMounted(() => {
		document.addEventListener('allSectionsLoaded', handleLoaded);
	});
	onBeforeUnmount(() => {
		document.removeEventListener('allSectionsLoaded', handleLoaded);
	});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", {
        class: _normalizeClass(_unref(addPadding))
      }, [
        (_unref(showOverview))
          ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
              _createElementVNode("a", {
                class: _normalizeClass(getIsLoadingClass(_unref(overviewCtaRoot))),
                href: "#demo-overview",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleClick($event, _unref(demoNavRoot))), ["prevent"]))
              }, _hoisted_5, 2)
            ]))
          : _createCommentVNode("", true),
        (_unref(showGallery))
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createElementVNode("a", {
                class: _normalizeClass(getIsLoadingClass(_unref(imageGalleryRoot))),
                href: "#detail-image-gallery-root",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleClick($event, _unref(imageGalleryRoot))), ["prevent"]))
              }, _hoisted_8, 2)
            ]))
          : _createCommentVNode("", true),
        (_unref(showEnquire))
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _createElementVNode("a", {
                class: _normalizeClass(getIsLoadingClass(_unref(formRoot))),
                href: "#detail-form-root",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleClick($event, _unref(formRoot))), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  (_unref(isTestDrive))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_15))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_19))
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_unref(showAdvantages))
          ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
              _createElementVNode("a", {
                class: _normalizeClass(getIsLoadingClass(_unref(advantageRoot))),
                href: "#detail-advantage-root",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleClick($event, _unref(advantageRoot))), ["prevent"]))
              }, _hoisted_22, 2)
            ]))
          : _createCommentVNode("", true),
        (_unref(showCustomise))
          ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
              (!_unref(showExternalCustomise))
                ? (_openBlock(), _createBlock(DetailOverviewCta, { key: 0 }))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "tb-button-solid-reverse",
                    onClick: _withModifiers(handleExternalCustomiseClick, ["prevent"]),
                    "data-button-name": "detail : customise vehicle"
                  }, "Customise", 8, _hoisted_24))
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})